import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { useStore } from "../../helpers";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        formControl: {
            margin: theme.spacing(1),
            minWidth: 250,
        },
    })
);

export const SourcesFilter = observer(() => {
    const { mediaStore } = useStore();
    const classes = useStyles();
    const [sources, setSources] = useState<string[]>([]);
    const [selected, setSelected] = useState(false);

    const sourceOptions = mediaStore.articles?.filters?.sources;
    if (!sourceOptions) return null;

    return (
        <div className="mx-4 flex max-w-sm flex-col flex-wrap overflow-hidden bg-white">
            <InputLabel className="pl-2">Media Sources</InputLabel>
            <FormControl className={classes.formControl}>
                <Select
                    multiple
                    variant="standard"
                    native={false}
                    onChange={(event) => {
                        const newSources = event.target.value as string[];
                        setSources(newSources);
                        mediaStore.printMediaFilters.sources = newSources;
                        setSelected(true);
                    }}
                    value={sources}
                    renderValue={() => <div>{sources.length} selected</div>}
                    className="max-w-sm"
                    displayEmpty
                >
                    {[...sourceOptions].sort().map((source) => (
                        <MenuItem key={source} value={source}>
                            {source}
                            {selected && sources.includes(source) ? (
                                <i className="fa-solid fa-check-circle ml-auto p-2 text-green-500" />
                            ) : null}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </div>
    );
});
